import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

const SHARED_ACTION_BUTTON_PROPS = {
  size: ButtonSize.SMALL,
  buttonStyle: ButtonStyle.CIRCLE_ICON,
};

export interface DashboardLinkTableActionButtonsProps {
  onEdit?: () => void; // if unspecified, the edit icon will not be rendered.
  onRemove?: () => void; // if unspecified, the remove icon will not be rendered.
}

export default function DashboardLinkTableActionButtons({
  onEdit,
  onRemove,
}: DashboardLinkTableActionButtonsProps): JSX.Element {
  return (
    <div
      className="u-justify-content-end"
      {...getTestProps({component: 'DashboardLinkConfigTableActionButtons', element: 'root'})}
    >
      {onEdit && (
        <Button
          {...SHARED_ACTION_BUTTON_PROPS}
          aria-label="Edit embedded dashboard"
          dataTestAttrs={{component: 'DashboardLinkConfigTableActionButtons', element: 'editButton'}}
          onClick={() => {
            onEdit();
          }}
          icon="edit"
        />
      )}
      {onRemove && (
        <Button
          {...SHARED_ACTION_BUTTON_PROPS}
          aria-label="Delete embedded dashboard"
          dataTestAttrs={{component: 'DashboardLinkConfigTableActionButtons', element: 'deleteButton'}}
          onClick={() => {
            onRemove();
          }}
          icon="delete"
        />
      )}
    </div>
  );
}
